import { postRequest } from "../../../utils/apiUtils"
import { loginFailure, loginSuccess } from "../../reducers/slices/loginSlice";

export const UserLogin = (userData) => {
    return async (dispatch) => {
        const { result, error } = await postRequest(`app_login`, userData);

        if(!error) {
            return dispatch(loginSuccess(result))
        }
        return dispatch(loginFailure(result))
    }
}